import {
  Form,
  Row,
  Col,
  Select,
  Button,
  Input,
  Tabs,
  DatePicker,
  Collapse,
  Card,
  Empty,
  Space,
  message
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  FormOutlined,
  DeleteOutlined,
  HddOutlined,
  UnorderedListOutlined,
  TeamOutlined,
  GoldOutlined,
  FilePdfOutlined,
  FileTextOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import commonFn from "@/utils/commonFn";
import dayjs from "dayjs";
import './index.scss'
import { CustomTable, CustomTableExtend, CustomModal } from "@/hocComponents";
import ListModal from "./component/ListModal";
import GroupModal from "./component/GroupModal";
import OwnerGroupPicker from "../OneLineCashFlowReport/OwnerGroupPicker";

const MainTable = forwardRef((props, ref) => {
  const initTableHead = {
    reportId: undefined,
    date: undefined,
    prop: undefined,
    type: undefined,
    glChartNameId: undefined,
    ownerIdList: undefined,
    propTypeList: undefined,
    trustIdList: undefined,
    propList: undefined,
    propIds: undefined
  }

  const [tableHead, setTableHead] = useState(initTableHead);
  
  const [form] = Form.useForm();
  const currentYearStr = Form.useWatch('currentYearStr', form);
  const [systemCurrentDate, setSystemCurrentDate] = useState(null);
  const [reportId, setReportId] = useState(null);
  const [leftDocFlag, setLeftDocFlag] = useState(true);
  const [reportList, setReportList] = useState([]);
  const [currentReportLabel, setCurrentReportLabel] = useState(null);
  const [propTypeList, setPropTypeList] = useState([]);
  const [trustList, setTrustList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const ownerGroupIdRef = useRef(null);
  const tableRequestRef = useRef(null);
  const [ownerGroupId, setOwnerGroupId] = useState(ownerGroupIdRef.current);
  const [reportGroupList, setReportGroupList] = useState([]);
  const [reportGroupListItem, setReportGroupListItem] = useState({});
  
  const [currentReportKey, setCurrentReportKey] = useState('1');

  const [month6Columns, setMonth6Columns] = useState([]);
  const [propsList, setPropsList] = useState([]);
  
  const [btnDisabled, setBtnDisabled] = useState(false);

  const initColumns = [
    {
      title: 'Description',
      dataIndex: "description",
      align: 'left',
      titleType: '',
      render: (text) => {
        return <div dangerouslySetInnerHTML={{ __html: text }}></div>;
      },
      onCell: () => ({
        style: {
          whiteSpace: 'nowrap',
        },
      }),
    },
  ]

  const getInitColumns1 = (reportKey = currentReportKey) => [
    {
      title: 'YTD',
      dataIndex: "ytd",
      titleType: '',
      hidden: !['1', '2'].includes(String(reportKey)),
      render: (text) => {
        return (
          <div className="OSMR700">
            {text}
          </div>
        )
      }
    },
    {
      title: '%',
      hidden: !['1', '2'].includes(String(reportKey)),
      dataIndex: "percent",
      titleType: '',
    },
    {
      title: 'Diff',
      dataIndex: "diff",
      titleType: '',
      hidden: !['3', '4'].includes(String(reportKey)),
      render: (text) => {
        return (
          <div className="OSMR700">
            {text}
          </div>
        )
      }
    },
  ]

  const [columns, setColumns] = useState([...initColumns, ...getInitColumns1()]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  const [exporting, setExporting] = useState("");

  const propDataDoc = (data, descList = []) => {
    return (
      <div className="OSMRPropItemDesc">
        {descList.map(item => {
          return (
            <div className={`OSMRPropItemDescItem ${item.isFlex2 && 'isFlex2' || ''}`} key={item.value}>
              <div className="OSMRPropItemDescItemLabel">{ item.label }</div>
              <div className={`OSMRPropItemDescItemValue ${item.isAmount && 'isAmount' || ''}`}>{ data?.[item.value] }</div>
            </div>
          )
        })}
      </div>
    )
  }

  const TabsChildrenDoc = ({descData, descList, tableList, tabKey}) => {
    return <>
      {descData && propDataDoc(descData, descList) || null}
      <CustomTable
        key={tabKey}
        tableLoading={tableLoading}
        columns={columns}
        tableList={tableList}
        pagination={false}
        rowClassName={(record) => {
          if(['SUBTOTAL', 'GROUP_HEADER'].includes(record.rowType)){
            return ["OSMR700"]
          }
          if(['STICKY'].includes(record.rowType)){
            return ["OSMR700", "OSMR_STICKY"]
          }
          return [record.vendorPaymentId]
        }}
        handleTableChange={handleTableChange}
        tableScrollY={descData ? (leftDocFlag ? "390px" : "430px") : (leftDocFlag ? "305px" : "345px")}
        tableCss="OSMRTable"
      />
    </>
  }

  const ownerDataList = [
    {
      label: 'Name',
      value: 'name',
    },
    {
      label: 'Address',
      value: 'address',
      isFlex2: true
    },
    {
      label: 'Active Props',
      value: 'activeCount',
    },
    {
      label: 'Inactive props',
      value: 'inActiveCount',
    },
    {
      label: 'Total Units',
      value: 'unitCount',
    },
    {
      label: 'Vacancy',
      value: 'vacancyNum',
    },
    {
      label: 'Eviction',
      value: 'evictionNum',
    }
  ]

  const propDataList = [
    {
      label: 'Property #',
      value: 'prop',
    },
    {
      label: 'Prop Class',
      value: 'propClass',
    },
    {
      label: 'Purchase Price',
      value: 'purchasePrice',
      isAmount: true
    },
    {
      label: 'Address',
      value: 'address',
      isFlex2: true
    },
    {
      label: 'Purchase Date',
      value: 'startTime',
    },
    {
      label: 'Number of Unit',
      value: 'units',
    }
  ]
  
  const rangePresets = Array.from({ length: 5 }, (_, index) => {
    const currentDate = (systemCurrentDate || dayjs()).subtract(index, "year");
    return {
      label: currentDate.year(),
      value: [currentDate.startOf("year"), currentDate.endOf("year")],
    };
  });

  const lastYearDate = currentYearStr?.[1]?.subtract(1, 'year');
  const handleCurrentYearChange = (values) => {
    const endDate = values?.[1]?.subtract(1, 'year');
    form.setFieldValue('lastYearStr', endDate ? [endDate.startOf('year'), endDate.endOf('year')] : undefined)
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    tableRequestRef.current?.abort();
    const controller = new AbortController();
    tableRequestRef.current = controller;
    setTableLoading(true);
    try {
      const params = {
        ...tableHead
      };
      const response = await http.post(api.operatingStatementMonthsList, params, {
        signal: controller.signal,
      });
      if(controller.signal.aborted || !response) return
      if(response?.code !== "1") {
        commonFn.modalFailedFn(response)
        return
      }
      const {propData, props, ownerData, owners, monthsDict, data} = response.data || {}
      month6ColumnsFn(monthsDict || [], tableHead.reportId);
      const list = (params?.type === 'owner' ? owners : props) || [];
      const propsListTemp = list.map(item => {
        return {
          key: item,
          label: item,
          forceRender: false,
          descData: params?.type === 'owner' ? ownerData?.[item] : propData?.[item],
          descList: params?.type === 'owner' ? ownerDataList : propDataList,
          tableList: data?.[item] || [],
        }
      })
      setPropsList(propsListTemp)
    } catch (error) {
      if(!controller.signal.aborted) {
        message.error('Failed to load the report. Please try again.')
      }
    } finally {
      if(tableRequestRef.current === controller) {
        tableRequestRef.current = null;
        setTableLoading(false);
      }
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    return getTableListFn(pagination?.current, pagination?.pageSize, tableHead);
  };

  const month6ColumnsFn = (monthsDict, reportKey = currentReportKey) => {
    const month6Columns = monthsDict?.map((month) => ({
      title: month?.label,
      dataIndex: month?.value,
      key: month?.value,
      width: month?.label?.includes(' - ') ? 200 : 100,
      onCell: () => ({className: 'cellAmount'}),
      render: (text, record) => {
        if(record?.months?.[month?.value] === '$0.00') return ''
        return record?.months?.[month?.value] || null
      },
    }));
    setMonth6Columns(month6Columns)
    setColumns([...initColumns, ...month6Columns, ...getInitColumns1(reportKey)]);
  };

  const initColunmsFn = () => {
    setTableHead(initTableHead);
    setColumns([...initColumns, ...month6Columns, ...getInitColumns1()]);
  }

  useEffect(() => {
    initColunmsFn()
  }, [refreshKey])

  const tabItems = propsList.map(item => ({
    key: item.key,
    label: item.label,
    forceRender: item.forceRender,
    children: (
      <TabsChildrenDoc
        key={item.key}
        descData={item.descData}
        descList={item.descList}
        tableList={item.tableList}
        tabKey={item.key}
      />
    ),
  }));

  const getCurrentDate = async() => {
    const cDate = await http.get(api.commonCurrentDate)
    const currentDate = cDate && dayjs(cDate)
    setSystemCurrentDate(currentDate)
    form.setFieldsValue({
      date: currentDate,
      currentYearStr: currentDate ? [currentDate.startOf('year'), currentDate] : undefined,
      lastYearStr: currentDate ? [currentDate.subtract(1, 'year').startOf('year'), currentDate.subtract(1, 'year').endOf('year')] : undefined
    });
  }
  
  const getReportList = async () => {
    const response = await http.get(api.operatingStatementMonthsReportDict);
    if(!response?.data?.length) return
    setReportList(response?.data || []);
    const {value, label} = response?.data?.[0]
    form.setFieldsValue({ reportId: value });
    setCurrentReportLabel(label)
  };

  const getPropTypeList = async () => {
    const response = await http.get(api.getPropTypeList);
    setPropTypeList(response?.data || []);
  };

  const getTrustIdList = async () => {
    const response = await http.get(api.getTrustDictList);
    setTrustList(response?.data || []);
  };

  const getOwnerIdList = async () => {
    const response = await http.get(api.getOwnerDictList);
    setOwnerList(response?.data || []);
  };

  const getReportGroupList = async () => {
    setReportGroupList([])
    setReportGroupListItem({})
    const response = await http.get(api.operatingStatementAnalysisReportList);
    if(response?.code === "1"){
      setReportGroupList(response?.data?.rowList || []);
      setReportGroupListItem(response?.data?.reportMap || {})
    }
  };

  useEffect(() => {
    getCurrentDate()
    getReportList()
    getPropTypeList()
    getTrustIdList()
    getOwnerIdList()
    getReportGroupList()
  }, []);

  useEffect(() => {
    return () => tableRequestRef.current?.abort()
  }, [])

  const formatDateRange = (dateRange = []) => dateRange.map(item => item.format('YYYY-MM-DD'))
  
  const submitFn = async() => {
    form.validateFields().then(value => {
      const params = {
        ...value,
        date: value?.date?.format('YYYY-MM-DD') || '',
        currentYearStr: formatDateRange(value.currentYearStr),
        lastYearStr: formatDateRange(value.lastYearStr),
      }
      setCurrentReportLabel(reportList.find(item => item.value === value.reportId)?.label); 
      setCurrentReportKey(value.reportId)
      setTableHead(params)
      getTableListFn(1, 20, params)
    }).catch(err =>{
      console.log(err,'===err');
    })
  }

  const exportFn = async(format) => {
    setExporting(format)
    try {
      const value = await form.validateFields()
      const params = {
        ...value,
        date: value?.date?.format('YYYY-MM-DD') || '',
        currentYearStr: formatDateRange(value.currentYearStr),
        lastYearStr: formatDateRange(value.lastYearStr),
      }
      const endpoint = format === 'pdf' ? api.operatingStatementMonthsToPdf : api.operatingStatementMonthsToCsv
      const blob = await http.post(endpoint, params, { responseType: 'blob' })
      if (!(blob instanceof Blob)) throw new Error('Invalid file response')
      if (blob.type.includes('application/json')) {
        throw new Error((JSON.parse(await blob.text()))?.msg || 'Export failed.')
      }
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `Operating_Statement_${dayjs().format('YYYYMMDD_HHmmss')}.${format}`
      link.click()
      window.setTimeout(() => window.URL.revokeObjectURL(url), 1000)
    } catch (error) {
      if (!error?.errorFields) message.error(error?.message || 'Export failed.')
    } finally {
      setExporting("")
    }
  }

  const ReportFormDoc = () => {
    const ownerOptions = ownerList.map(item => {
      return {
        value: item.ownerId,
        label: item.titleName || item.ownerName,
      }
    })

    return <>
      <Form
        form={form}
        layout="vertical"
        labelWrap={true}
        labelAlign="right"
        initialValues={{
            prop: '0001-ZZZZ',
            type: "consolidate",
        }}
        validateMessages={{
          required: "${label} is required!",
        }}
        onValuesChange={(changed) => {
          if(Object.prototype.hasOwnProperty.call(changed, "ownerIdList")){
            ownerGroupIdRef.current = null
            setOwnerGroupId(null)
          }
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="reportId"
              label="Report"
              rules={[{ required: true, message: 'Report is required!' }]}
            >
              <Select
                allowClear
                popupMatchSelectWidth={false}
                placeholder="Select a type"
                optionFilterProp="label"
                onChange={(e) => setReportId(e)}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'label',
                  value: 'value',
                }}
                options={reportList}
              />
            </Form.Item>

            <Form.Item
              label="Group By"
              name="type"
              rules={[{ required: true, message: 'Group By is required!' }]}
            >
              <Select
                allowClear
                placeholder="Select a type"
                options={[
                  { label: "Consolidate Sum", value: "consolidate" },
                  { label: "Property", value: "prop" },
                  { label: "Owner", value: "owner" },
                ]}
              />
            </Form.Item>

            {reportId != 3 ? <Form.Item
              name="date"
              label="Date"
              rules={[{ required: true, message: 'Date is required!' }]}
            >
              <DatePicker
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
              />
            </Form.Item> : <>
              <Form.Item
                name="currentYearStr"
                label="Current Year"
                rules={[{ required: true, message: 'Current Year is required!' }]}
              >
              <DatePicker.RangePicker
                presets={rangePresets}
                onChange={handleCurrentYearChange}
                disabledDate={(current, info) => info.from && !current.isSame(info.from, 'year')}
              />
              </Form.Item>

              <Form.Item
                name="lastYearStr"
                label="Last Year"
                rules={[{ required: true, message: 'Last Year is required!' }]}
              >
              <DatePicker.RangePicker
                disabledDate={(current) => !lastYearDate || !current.isSame(lastYearDate, 'year')}
              />
              </Form.Item>
            </>
            }
            <Form.Item
              name="prop"
              label="Prop"
              rules={[{ required: true, message: 'Prop is required!' }]}
            >
              <Input.TextArea
                placeholder="Please input Prop"
                autoSize={{ minRows: 3, maxRows: 10 }}
              />
            </Form.Item>

            <Form.Item label="Property Type" name="propTypeList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.name ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'name',
                  value: 'code',
                }}
                options={propTypeList}
              />
            </Form.Item>

            <Form.Item label="Trust" name="trustIdList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.trustNameTitle ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                fieldNames={{
                  label: 'trustNameTitle',
                  value: 'trustId',
                }}
                options={trustList}
              />
            </Form.Item>

            <Form.Item label="Owner" name="ownerIdList">
              <Select
                showSearch
                allowClear
                mode="multiple"
                placeholder="Select a type"
                optionFilterProp="label"
                options={ownerOptions}
              />
            </Form.Item>

            <OwnerGroupPicker
              value={ownerGroupId}
              ownerOptions={ownerOptions}
              onSelect={(group) => {
                const groupId = group?.id ?? null
                ownerGroupIdRef.current = groupId
                setOwnerGroupId(groupId)
                form.setFieldsValue({
                  ownerIdList: group?.ownerIds || []
                })
              }}
            />

          </Col>
        </Row>
      </Form>
      <div style={{textAlign:'center'}}>
        <Button type="primary" style={{ width: '100%'}} onClick={() => submitFn()} loading={tableLoading} disabled={btnDisabled}>
          Submit
        </Button>
      </div>    
    </>
  }

  const customModalRef = useRef(null);
  const [currentRecord, setCurrentRecord] = useState(null);

  const deleteGroupFn = (record) => {
    setCurrentRecord({
      ...record,
      deleteIdKey: 'reportGroupId',
      deleteUrl: api.operatingStatementAnalysisDeleteGroup
    })
    customModalRef.current.openModalFn()
  }

  const deleteFn = async() => {
    const response = await http.get(currentRecord.deleteUrl, {
      params: {
        id: currentRecord[currentRecord.deleteIdKey]
      },
    });
    if (response.code === "1") {
      message.success("Successfully delete.");
      getReportGroupList()
    } else {
      commonFn.modalFailedFn(response);
    }
  }
  
  const deleteItemFn = (record) => {
    setCurrentRecord({
      ...record,
      deleteIdKey: 'reportListId',
      deleteUrl: api.operatingStatementAnalysisDeleteList
    })
    customModalRef.current.openModalFn()
  }

  const createGroupModalRef = useRef(null);

  const createListModalRef = useRef(null);

  const ReportCreatorDoc = () => {
    return <>
      <div className="OSMRLeftRGLTop">
        <Button
          onClick={submitFn}
          icon={<HddOutlined />}
          loading={tableLoading}
          style={{backgroundColor: '#f39c12', color: '#fff'}}
        >
          New Summary
        </Button>
        <Button
          onClick={() => createListModalRef.current.openModal()}
          icon={<UnorderedListOutlined />}
          style={{backgroundColor: '#f39c12', color: '#fff'}}
        >
          New List
        </Button>
        <Button
          onClick={() => createGroupModalRef.current.openModal()}
          icon={<TeamOutlined />}
          style={{backgroundColor: '#3c8dbc', color: '#fff'}}
        >
          New Group
        </Button>
        <Button
          onClick={submitFn}
          icon={<GoldOutlined />}
          loading={tableLoading}
          style={{backgroundColor: '#3c8dbc', color: '#fff'}}
        >
          New Total
        </Button>
      </div>
      {
        reportGroupList?.map(item => {
          return <div className="OSMRLeftRGL" key={item.reportGroupId}>
            <div className="OSMRLeftRGLTitle">
              <span className="OSMRLeftRGLTitleLeft">
                {item.nameGroup}
              </span>
              <span className="OSMRLeftRGLTitleRight">
                <Button
                  onClick={() => createGroupModalRef.current.openModal({isEidt: true, record: item})}
                  icon={<FormOutlined />}
                  type="link"
                />
                <span className="OSMRLeftRGLTitleRightLine"></span>
                <Button
                  onClick={() => deleteGroupFn(item)}
                  icon={<DeleteOutlined />}
                  danger
                  type="link"
                />
              </span>
            </div>
            {
              reportGroupListItem?.[item.reportGroupId]?.map(v => {
                return <div className="OSMRLeftRGLItem" key={v.reportListId}>
                  <span className="OSMRLeftRGLItemLeft">
                    <Button
                      onClick={() => createListModalRef.current.openModal({isEidt: true, record: v})}
                      icon={<FormOutlined />}
                      type="link"
                    />
                    <span className="OSMRLeftRGLTitleRightLine"></span>
                    <Button
                      onClick={() => deleteItemFn(v)}
                      icon={<DeleteOutlined />}
                      danger
                      type="link"
                    />
                  </span>
                  <span className="OSMRLeftRGLItemRight">
                   {v.nameList}
                  </span>
                </div>
              })
            }
          </div>
        })
      }
    </>
  }

  return (
    <div className={`OperatingStatementAnalysis ${currentReportLabel === 'Trailing 12 Months' ? 'pageMaxWidth2880' : 'pageMaxWidth'}`}>
      {leftDocFlag && <Card
        className="OSMRLeft"
        title={(
          <div className="OSMRFilterHeader">
            <span>Report filters</span>
            <Button
              className="OSMRCollapse"
              type="text"
              icon={<UpOutlined />}
              onClick={() => setLeftDocFlag(false)}
            >
              Hide filters
            </Button>
          </div>
        )}
      >
        <Collapse items={[
          {
            key: '1',
            label: 'Report Form',
            children: ReportFormDoc(),
          },
          {
            key: '2',
            label: 'Report Creator',
            children: ReportCreatorDoc(),
          },
        ]} defaultActiveKey={['1']} accordion />
      </Card>}
      <ListModal
        ref={createListModalRef}
        submitInitFn={getReportGroupList}
      />
      <GroupModal 
        ref={createGroupModalRef}
        submitInitFn={getReportGroupList}
      />
      <CustomModal
        ref={customModalRef}
        customConfig={{
          width: 500,
          content: 'Are you sure to delete selected data?',
          onOkFn: deleteFn,
        }}
      />
      <div className="OSMRRight">
        {!leftDocFlag && <div className="OSMRShowFilters">
          <Button
            className="OSMRCollapse"
            type="text"
            icon={<DownOutlined />}
            onClick={() => setLeftDocFlag(true)}
          >
            Show filters
          </Button>
        </div>}
        <Card
          className="OSMRResultCard"
          title={(
            <div className="OSMRTitle">
              <span className="OSMRReportMark"><FileTextOutlined /></span>
              <div>
                <div className="OSMRTitleLabel">{currentReportLabel || 'Report preview'}</div>
                <small>Operating Statement Analysis</small>
              </div>
            </div>
          )}
          extra={(
            <Space>
              <Button icon={<FileTextOutlined />} loading={exporting === "csv"} onClick={() => exportFn("csv")}>CSV</Button>
              <Button type="primary" icon={<FilePdfOutlined />} loading={exporting === "pdf"} onClick={() => exportFn("pdf")}>PDF</Button>
            </Space>
          )}
        >
          <div className="OSMRMain">
            <div className="OSMRPropList">
              {tabItems.length ? <Tabs
                className="OSMRTabs"
                items={tabItems}
                animated
                destroyInactiveTabPane
                more={{
                  trigger: 'click',
                  placement: 'bottomLeft',
                }}
              /> : <Empty
                className="OSMREmpty"
                description="Run the report to review data."
              />}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
});
export default MainTable;
